import type { FC } from 'react'

import escapeRegExp from 'lodash/escapeRegExp'

import './Highlight.styles.scss'

const Highlight: FC<{ text: string | undefined; pattern?: string }> = ({
  text = '',
  pattern = '',
}) => {
  if (!text) return null

  if (!pattern.trim()) {
    return <span>{text}</span>
  }

  const regex = new RegExp(`(${escapeRegExp(trimQuotationMarks(pattern))})`, 'gi')
  const parts = text.split(regex)

  return (
    <span>
      {parts.filter(Boolean).map((part, i) =>
        regex.test(part) ? (
          <span className="highlight" key={i}>
            {part}
          </span>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </span>
  )
}

export default Highlight

function trimQuotationMarks(input: string): string {
  return input.replace(/^"|"$/g, '')
}
